import React from 'react'
import { useTheme } from '~/common/theme'

import { IconBaseProps } from './IconBase'
import Icons, { IconNames, FilledNames } from './Icons'

// This handles to avoid evaluate 'filled' keyword on else
// condition, nut should be better more constrained in future
// to avoid accept filled boolean true and a keyword that is
// not inside Icons.filled
type IconNamesWithoutFilled = Exclude<IconNames, 'filled'>

export interface IconProps extends IconBaseProps {
  name: IconNames
  className?: string
  disabled?: boolean
  height?: string
  width?: string
  style?: Record<string, any>
  filled?: boolean
  boldOutline?: boolean
  isExpanded?: boolean
}

const Icon: React.FC<IconProps> = ({ name, filled, ...rest }) => {
  const theme = useTheme()

  if (!name) return null

  const IconComponent = filled
    ? Icons.filled[name as FilledNames]
    : Icons[name as IconNamesWithoutFilled]

  return <IconComponent {...rest} aria-label={`${name} Icon`} theme={theme} />
}

export default Icon
